import React, { useState } from 'react'
import { useNavigate } from 'react-router'
import logo from '../../assets/images/SportMinglePrimaryLogo.png'
import { useDispatch } from 'react-redux';
import { rootAction } from '../../redux/reducer/rootReducer';

const EntryOption = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const [selectedOption, setSelectedOption] = useState("")

    const handleRedirection = () => {
        if (!selectedOption) {
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'warning', content: "Please select 1 option" }));
            return;
        }
        if (selectedOption === 'guest_reg') {
            navigate("/register-guest?token=" + token)
        } else if (selectedOption === 'login') {
            navigate("/login", {
                state: {
                    'token': token
                }
            })
        }
    }
    return (
        <div className='sm_entry_options_con'>
            <div className='sm_entry_options_list'>
                <img src={logo} alt="" />
                <h1>Welcome to SportMingle</h1>
                <h3>Sign in or create an account to continue.</h3>
                <br />

                <div onClick={() => setSelectedOption("guest_reg")} className={selectedOption === 'guest_reg' ? 'sm_entry_options_body select' : 'sm_entry_options_body'}>
                    <h2>New to SportMingle?</h2>
                    <h4>Create an account whenever you’re ready.</h4>
                </div>
                <div onClick={() => setSelectedOption("login")} className={selectedOption === 'login' ? 'sm_entry_options_body select' : 'sm_entry_options_body'}>
                    <h2>Already have an account?</h2>
                    <h4>Sign in to access your teams, events, and messages.</h4>
                </div>


                <br />
                <button onClick={handleRedirection}>Continue</button>
            </div>
        </div>
    )
}

export default EntryOption